import { FormSection } from './models/form-wizard.models';

export function getFormSectionId<T = any>(section: FormSection<T>, index: number): string {
  return typeof section.id === 'string' && section.id.trim().length > 0
    ? section.id
    : `section-${index}`;
}
